import React, { useState, useEffect } from "react";
import { loadTestingProtocols } from "./Fetching";
import Link from "../Link";

// Load the testing protocols and display them in a table with the headings 'name' and 'matrix'
export default function TestingProtocols({
  company_id,
  branch_id,
  onClose,
  registerProtocol,
}) {
  const [protocols, setProtocols] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const fetchTestingProtocols = () => {
    loadTestingProtocols({ company_id, branch_id, with_testing_actions: true }).then(
      (json) => {
        setProtocols(json.testing_protocols);
        setLoaded(true);
      }
    );
  };

  useEffect(fetchTestingProtocols, []);

  const renderProtocols = () => {
    if (protocols.length === 0) {
      return (
        <p className="alert alert-default">
          {I18n.t("sample_registration.no_protocols_available")}
        </p>
      );
    }
    return (
      <div>
        <table className="table table-condensed table-hover" style={{ marginBottom: 0 }}>
          <thead>
            <tr>
              <th style={{ width: 170 }} />
              <th>Name</th>
              <th className="text-center" style={{ width: 160 }}>
                {I18n.t("matrix")}
              </th>
            </tr>
          </thead>
          <tbody>
            {protocols.map((protocol) => (
              <tr key={protocol.id}>
                <td>
                  <Link
                    className="btn btn-xs btn-default"
                    onClick={() => registerProtocol(protocol.id)}
                  >
                    Register
                  </Link>
                  <a
                    class="btn btn-xs btn-default"
                    href={"/products/shelf_life_protocols/" + protocol.id}
                  >
                    View Protocol
                  </a>
                </td>
                <td>{protocol.name}</td>
                <td className="text-center">{protocol.matrix}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div>
      {loaded ? (
        renderProtocols()
      ) : (
        <p>
          <i className="fa fa-spin fa-spinner" />
          &nbsp; Loading protocols...
        </p>
      )}
    </div>
  );
}
